import { render, staticRenderFns } from "./ProfileDownloadControls.vue?vue&type=template&id=2bffe996"
import script from "./ProfileDownloadControls.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileDownloadControls.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports